/**
 * Filing-mode values, radio options, and detail-field copy for Filing Info.
 * @module enums/filingMode
 */

/** Filing-mode option values shared with save validation and cell display. */
export const FILING_MODE = {
  PORTAL: "portal",
  FAX: "fax",
  CALL: "call",
  NOT_APPLICABLE: "not_applicable",
} as const;

/** Radio options for choosing how a J-code / CPT code is filed. */
export const FILING_MODE_OPTIONS = [
  { label: "Portal", value: FILING_MODE.PORTAL },
  { label: "Fax", value: FILING_MODE.FAX },
  { label: "Call", value: FILING_MODE.CALL },
  { label: "Not Applicable", value: FILING_MODE.NOT_APPLICABLE },
];

/** Label and placeholder copy for modes that show a details SearchableCard. */
export const FILING_DETAIL_COPY: Record<
  string,
  { label: string; placeholder: string }
> = {
  [FILING_MODE.PORTAL]: {
    label: "Select the Portal name used for filing the J-code / CPT code :",
    placeholder: "Select Portal name",
  },
  [FILING_MODE.FAX]: {
    label: "Enter the fax number used for filing the J-code / CPT code :",
    placeholder: "Enter fax number",
  },
};
